<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M20.999 17.2002C21.4408 17.2002 21.7987 17.5583 21.7988 18C21.7988 18.4418 21.4409 18.7998 20.999 18.7998H2.99902C2.55729 18.7997 2.19922 18.4418 2.19922 18C2.19932 17.5583 2.55735 17.2003 2.99902 17.2002H20.999ZM20.999 11.2002C21.4408 11.2002 21.7987 11.5583 21.7988 12C21.7988 12.4418 21.4409 12.7998 20.999 12.7998H2.99902C2.55729 12.7997 2.19922 12.4418 2.19922 12C2.19932 11.5583 2.55735 11.2003 2.99902 11.2002H20.999ZM20.999 5.2002C21.4408 5.2002 21.7987 5.55826 21.7988 6C21.7988 6.44183 21.4409 6.7998 20.999 6.7998H2.99902C2.55729 6.7997 2.19922 6.44176 2.19922 6C2.19932 5.55833 2.55735 5.2003 2.99902 5.2002H20.999Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMenu',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
